import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMusicNote = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5 8.89026V18.5002M12.5 8.89026V5.57681C12.5 5.36946 12.5 5.26579 12.5347 5.17757C12.5653 5.09968 12.615 5.03072 12.6792 4.97702C12.752 4.91621 12.8503 4.88343 13.047 4.81786L17.447 3.35119C17.8025 3.23269 17.9803 3.17344 18.1218 3.20897C18.2456 3.24007 18.3529 3.31737 18.4216 3.42504C18.5 3.54803 18.5 3.7354 18.5 4.11014V7.42359C18.5 7.63094 18.5 7.73461 18.4653 7.82282C18.4347 7.90072 18.385 7.96968 18.3208 8.02338C18.248 8.08419 18.1497 8.11697 17.953 8.18254L13.553 9.6492C13.1975 9.76771 13.0197 9.82696 12.8782 9.79143C12.7544 9.76033 12.6471 9.68302 12.5784 9.57536C12.5 9.45237 12.5 9.265 12.5 8.89026ZM12.5 18.5002C12.5 19.8809 10.933 21.0002 9 21.0002C7.067 21.0002 5.5 19.8809 5.5 18.5002C5.5 17.1195 7.067 16.0002 9 16.0002C10.933 16.0002 12.5 17.1195 12.5 18.5002Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMusicNote;
